import { SlideOver } from '@hakimo-ui/hakimo/ui-elements';
import { PersonProfileFilters } from '../types';
import { FilterPanelContent } from './index';

interface Props {
  open: boolean;
  filters: PersonProfileFilters;
  onClose: () => void;
  onApplyFilters: (filters: PersonProfileFilters) => void;
  showBadgeId?: boolean;
}

function FilterPanel(props: Props) {
  const { open, onClose, onApplyFilters, filters, showBadgeId = false } = props;

  return (
    <SlideOver title="Person Profile Filters" open={open} onClose={onClose}>
      <FilterPanelContent
        filters={filters}
        onApplyFilters={onApplyFilters}
        showBadgeId={showBadgeId}
      />
    </SlideOver>
  );
}

export default FilterPanel;
